module.exports = __webpack_public_path__ + "img/horizontal_2_1_8003.d82676c0.png";